export default "__VITE_ASSET__DFPZLPDm__"